import styled, { css } from "styled-components";

import logo from "assets/images/logo-nahartime.svg";
import { breakpoint } from "styles/mixins";

export const HeaderContainer = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${(p) => p.theme.color.white};
  z-index: 6;
  direction:rtl
`;

export const CovidBanner = styled.div`
  height: 80px;
  background: url(${(p) => p.img}) center center #e0ad33 no-repeat;
`;

export const Wrapper = styled.div`
  position: relative;
  width: calc(100% - 350px);
  padding: 10px;
  height: 65px;

  ${breakpoint.greaterThan("desktop")`
    ${(p) =>
      !p.isOrderPage &&
      css`
        height: 80px;
      `}
  `}

  ${breakpoint.greaterThan("superlarge")`
    max-width: 1400px;
  `}
	${breakpoint.lessThan("tablet")`
    width:100%
  `}
`;

export const Logo = styled.span`
  a {
    position: absolute;
    top: 50%;
    background: url("${logo}") left center / cover no-repeat;
    height: 30px;
    width: 26px;

    ${(p) =>
      p.$isHome
        ? css`
            transform: translateY(-50%);
            width: 113px;
            height: 25px;
            right: 0;
          `
        : css`
            transform: translate(-50%, -50%);
            left: 50%;
          `}

    ${breakpoint.greaterThan("tablet")`
      height: 25px;
      width: 113px;
    `}
  }
`;

export const Left = styled.div`
  float: left;
  margin-top: 5px;

  ${breakpoint.greaterThan("desktop")`
    margin-top: 10px;
    .credit {
      display: none
    }
  `}
`;

export const Right = styled.div`
  float: right;
  margin-top: 10px;
  direction: rtl;

  .credit {
    display: none;
    margin-right: 10px;
  }

  ${breakpoint.greaterThan("desktop")`
    .credit {
      display: inline;
    }
  `}
`;

export const Username = styled.span`
  margin-right: 10px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 115px;
  display: inline-block;
  white-space: nowrap;
  vertical-align: middle;

  ${breakpoint.greaterThan("desktop")`
    font-size: 16px;
    max-width: initial;
  `}
`;

export const BackButton = styled.a`
  margin-top: 5px;
  float: left;

  span {
    margin-left: 10px;
    display: none;
  }

  ${breakpoint.greaterThan("desktop")`
    margin-top: 0;

    span {
      display: inline-block;
    }
  `}
`;
